import { render, staticRenderFns } from "./datatablePatente.vue?vue&type=template&id=063c5835&"
import script from "./datatablePatente.vue?vue&type=script&lang=ts&"
export * from "./datatablePatente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('063c5835', component.options)
    } else {
      api.reload('063c5835', component.options)
    }
    module.hot.accept("./datatablePatente.vue?vue&type=template&id=063c5835&", function () {
      api.rerender('063c5835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlPatentes/datatablePatente.vue"
export default component.exports